import React, { useContext, useState, useEffect } from "react";
import GooglePlacesAutocomplete, { geocodeByPlaceId } from "react-google-places-autocomplete";
import { UserContext } from "../../../App";
import FaLocationDot from "react-icons/fa"

const GoogleAutoComplte = () => {
  const UserData = useContext(UserContext);
  const [address, setAddress] = useState();
  const [addressObj, setAddressObj] = useState();

  const getCityName = (address_components) => {
    let city = "";

    address_components.forEach((component) => {
      if (component.types.includes("locality")) {
        city = component.long_name;
      }
    });

    return city;
  };

  useEffect(() => {
    const detectUserLocation = () => {
      if ("geolocation" in navigator) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then((permissionStatus) => {
            if (permissionStatus.state === "granted") {
              navigator.geolocation.getCurrentPosition(
                async (position) => {
                  const { latitude, longitude } = position.coords;
                  const geocoder = new window.google.maps.Geocoder();
                  const latlng = { lat: latitude, lng: longitude };

                  geocoder.geocode({ location: latlng }, async (results, status) => {
                    if (status === "OK" && results[0]) {
                      setAddress({ label: getCityName(results[0].address_components), value: { place_id: results[0].place_id } });
                    }
                  });
                },
                (error) => {
                  console.error("Error getting user location:", error);
                }
              );
            } else if (permissionStatus.state === "prompt") {
              // Show a prompt to request geolocation permission
              navigator.geolocation.getCurrentPosition(
                () => {
                  // The user granted permission
                  detectUserLocation();
                },
                (error) => {
                  console.error("Error getting user location:", error);
                }
              );
            }
          })
          .catch((error) => {
            console.error("Error checking geolocation permission:", error);
          });
      } else {
        console.error("Geolocation not available in this browser.");
      }
    };

    // Automatically detect user's location when the component mounts
    detectUserLocation();
  }, []);

  useEffect(() => {
    const func = async () => {
      const geocodeObj =
        address &&
        address.value &&
        (await geocodeByPlaceId(address.value.place_id));
      UserData.setsearchBoxLocaity(address?.label);
      const addressObject =
        geocodeObj && getCityName(geocodeObj[0].address_components);

      setAddressObj(addressObject);
    };
    func();
  }, [address]);

  return (
    <div className="App">
      <div style={{ border: '1.5px solid black', borderRadius: '4px'}}>
        <GooglePlacesAutocomplete
          apiKey="AIzaSyDEnLDetZt4PvT03AWs7ZTyzAdA3K-Sz1g"
          selectProps={{
            isClearable: true,
            value: address,
            onChange: (val) => {
              setAddress(val);
            },
            placeholder: 'Enter City Name',
            styles: {
              input: (provided) => ({
                ...provided,
                boxShadow: 0,
                padding: "4px",
                "&:hover": {
                  border: "1px solid purple",
                },
              }),
              singleValue: (provided) => ({
                ...provided,
                boxShadow: 0,
                "&:hover": {
                  border: "1px solid purple",
                },
              }),
            },
          }}
          autocompletionRequest={{
            types: ['(cities)'], // Restrict autocomplete to cities only
          }}
        />
      </div>
    </div>
  );
};

export default GoogleAutoComplte;
